import { InteractionTag, InteractionTagPrimary, TagGroup } from "@fluentui/react-components";
import { useRootStore } from "Store/RootStore";
import { observer } from "mobx-react";
import React, { SyntheticEvent, useCallback, use } from "react";
import { useUniversalSearchFiltersStyles } from "./UniversalSearchFilters.styles";
import { parseQuery, buildQuery } from "Store/utils/searchQueryParser";
import { SearchContext } from "Shared/Components/SearchBox/SearchStore";

const UniversalSearchFiltersBase = () => {
    const universalSearchStore = useRootStore("UniversalSearchStore");
    const searchStore = use(SearchContext);

    const classes = useUniversalSearchFiltersStyles();

    const onTagSelect = useCallback(
        (e: Event | SyntheticEvent<Element, Event>, data: { value: string }) => {
            if (data.value === "More Filters") {
                universalSearchStore.searchWord = "is:";
                searchStore?.setKeyword(universalSearchStore.searchWord);
                return;
            }
            const currentFilter = universalSearchStore.filters.length > 0 ? universalSearchStore.filters[0] : null;
            const newFilter = currentFilter === data.value ? null : data.value;
            universalSearchStore.setFilter(newFilter);

            const { text } = parseQuery(universalSearchStore.searchWord);
            universalSearchStore.searchWord = buildQuery(text, newFilter);
            searchStore?.setKeyword(universalSearchStore.searchWord);
        },
        [universalSearchStore, searchStore]
    );

    return (
        universalSearchStore.isGlobalSearch && (
            <TagGroup aria-label="UniversalSearch Filters" onTagSelect={onTagSelect} selectedValues={universalSearchStore.filters} className={classes.tagGroup}>
                {[...universalSearchStore.currentCategories].map((filter) => (
                    <InteractionTag key={filter} shape="circular" value={filter} size="small" disabled={!universalSearchStore.isGlobalSearch}>
                        <InteractionTagPrimary>{filter}</InteractionTagPrimary>
                    </InteractionTag>
                ))}
            </TagGroup>
        )
    );
};

export const UniversalSearchFilters = observer(UniversalSearchFiltersBase);
